import { render, staticRenderFns } from "./reg_form_builder.vue?vue&type=template&id=773d979a&"
import script from "./reg_form_builder.vue?vue&type=script&lang=js&"
export * from "./reg_form_builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports